import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Home from './components/DefaultLayout/Layout/layout'
import Login from './views/Pages/Login/login.js'
import SignUp from './views/Pages/SignUp/SignUp.js'
import ForgetPassword from './views/Pages/ForgetPassword/forgetpassword'
import CodeVerify from './views/Pages/CodeVerfication/code';
import './App.css'
import {init} from './redux/Action/ChatAction'


class App extends Component {
  componentWillMount(){
    this.props.init()
  }
  render() {

    return (
      <BrowserRouter>
        <Switch>
          <Route path="/login" name="Login Page" component={Login} />
          <Route path="/registeration" name="Signup Page" component={SignUp} />
          <Route path="/forget-password" name="forget " component={ForgetPassword} />
          <Route path="/verifyaccount" name="verify Page" component={CodeVerify} />
          {/* <Route path="/home" name="home " component={Home} /> */}
          <Route path="/" name="Home" component={Home}/>

        </Switch>
      </BrowserRouter>
    );
  }
}
const mapStateToProps = state => {
  return {
  }

}

const mapDispatchToProps = dispatch => bindActionCreators(
  {
    init
  }
  , dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(App);






